// src/middleware/auth.ts

import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { getAccessToken } from '@/contexts/auth-context'

export default function auth(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const isAuthenticated = !!getAccessToken()

  if (!isAuthenticated) {
    next({ name: 'auth-login' })
  } else {
    next()
  }
}
